import { getBookingAccessState } from '@/utils/bookingAccess'

/** 仅派生CBS资格；用户和企业数据均由user模块统一加载和保存。 */
export default {
  namespaced: true,
  state: {},
  getters: {
    access: (state, getters, rootState) => getBookingAccessState({
      phase: rootState.user.identityPhase,
      userInfo: rootState.user.userInfo,
      companyInfo: rootState.user.companyInfo
    })
  },
  actions: {
    refresh({ dispatch, rootGetters }, force = false) {
      return dispatch('user/loadIdentity', force, { root: true }).then(() => rootGetters['bookingAccess/access'])
    }
  }
}
